module.exports = __webpack_public_path__ + "img/3year-bar.70e149b7.png";